/**
 * Inline SVG flag icons for supported locales.
 * Replaces emoji flags for cross-platform consistency.
 */

interface FlagIconProps {
  code: string;
  size?: number;
  className?: string;
}

function FrFlag({ size }: { size: number }) {
  return (
    <svg width={size} height={size * 0.75} viewBox="0 0 60 40" className="rounded-sm">
      <rect width="20" height="40" fill="#002395" />
      <rect x="20" width="20" height="40" fill="#FFFFFF" />
      <rect x="40" width="20" height="40" fill="#ED2939" />
    </svg>
  );
}

function RoFlag({ size }: { size: number }) {
  return (
    <svg width={size} height={size * 0.75} viewBox="0 0 60 40" className="rounded-sm">
      <rect width="20" height="40" fill="#002B7F" />
      <rect x="20" width="20" height="40" fill="#FCD116" />
      <rect x="40" width="20" height="40" fill="#CE1126" />
    </svg>
  );
}

function GbFlag({ size }: { size: number }) {
  return (
    <svg width={size} height={size * 0.75} viewBox="0 0 60 40" className="rounded-sm">
      <rect width="60" height="40" fill="#012169" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#FFFFFF" strokeWidth="6" />
      <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="3" />
      <path d="M30,0 V40 M0,20 H60" stroke="#FFFFFF" strokeWidth="10" />
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="6" />
    </svg>
  );
}

function DeFlag({ size }: { size: number }) {
  return (
    <svg width={size} height={size * 0.75} viewBox="0 0 60 40" className="rounded-sm">
      <rect width="60" height="13.33" fill="#000000" />
      <rect y="13.33" width="60" height="13.33" fill="#DD0000" />
      <rect y="26.67" width="60" height="13.33" fill="#FFCC00" />
    </svg>
  );
}

const FLAG_MAP: Record<string, React.FC<{ size: number }>> = {
  fr: FrFlag,
  ro: RoFlag,
  en: GbFlag,
  de: DeFlag,
};

export function FlagIcon({ code, size = 20, className }: FlagIconProps) {
  const Flag = FLAG_MAP[code];
  if (!Flag) return null;
  return (
    <span className={`inline-flex items-center shrink-0 ${className || ''}`}>
      <Flag size={size} />
    </span>
  );
}
